import styled from 'styled-components';
import { SendingPlatform } from 'modules/sendingPlatforms/constants';
import { spacing, H4 } from 'ui/theme';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { Add24 } from 'ui/icons';
import { useModalsContext } from '../../../contexts';

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.plusHalf};
  white-space: nowrap;
`;

export const Heading = styled(H4)`
  margin-bottom: 0;
  margin-right: ${spacing.base};
`;

export const EmailAccountsHeader = ({ sendingPlatform }: { sendingPlatform: SendingPlatform }) => {
  const { showCreateAccountModal } = useModalsContext();
  return (
    <Header data-test="sending-platform-details-accounts-header">
      <Heading>Accounts</Heading>
      <PrimaryButton
        size={BUTTON_SIZES.LARGE}
        onClick={() => showCreateAccountModal(sendingPlatform)}
      >
        <Add24 />
        <span>Add account</span>
      </PrimaryButton>
    </Header>
  );
};
